export const DELIVERY_TYPE_UTILS = {
  SHIPS_TO_SCHOOL: {
    clazz: 'shipToSchoolPill',
    translationKey: 'SHIPS_TO_SCHOOL',
    iconName: 'truck',
    altText: 'Truck Fast'
  },
  SHIPS_TO_HOME: {
    clazz: 'shipToHomePill',
    translationKey: 'SHIPS_TO_HOME',
    iconName: 'truck',
    altText: 'Truck Fast'
  },
  DIGITAL: {
    clazz: 'digitalPill',
    translationKey: 'DIGITAL',
    iconName: 'cloud-download',
    altText: 'Cloud Download'
  }
};
